import BaseModel from './BaseModel'
import axiosInstance from 'api/axios.config'
import {
  PLAYLIST_FOLLOWED,
  PLAYLIST_UNFOLLOWED
} from '../redux/actions/playlistFollowers.js'

class PlaylistFollower extends BaseModel {
  static reducer (action, _, session) {
    const playlist = session.Playlist.withId(action.uuid)
    switch (action.type) {
      case PLAYLIST_FOLLOWED:
        playlist.update({
          following: true
        })
        break
      case PLAYLIST_UNFOLLOWED:
        playlist.update({
          following: false
        })
        break
    }
  }

  static create (uuid) {
    return axiosInstance.post(`/playlists/${uuid}/followers`)
  }

  static destroy (uuid) {
    return axiosInstance.delete(`/playlists/${uuid}/followers`)
  }
}

PlaylistFollower.modelName = 'PlaylistFollower'

export default PlaylistFollower
